<template>
  <el-form :model="form" label-width="95px" :disabled="mode === 'view'">
    <el-form-item label="数据来源">
      <el-select v-model="form.dataSource" placeholder="请选择" filterable @change="selectChange">
        <el-option
          v-for="item in columnData"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="图片展示">
      <el-select v-model="form.imageFit" placeholder="请选择" filterable @change="selectChange">
        <el-option
          v-for="item in imageFitType"
          :key="item.value"
          :label="item.name"
          :value="item.value"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="轮播速度">
      <el-select v-model="form.speed" @change="selectChange">
        <el-option :label="0" :value="0"></el-option>
        <el-option v-for="item in 3" :key="item" :label="item" :value="item"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="展示条数">
      <el-input-number
        v-model="form.pageSize"
        :min="1"
        :max="10"
        @change="selectChange"
        controls-position="right"
        class="w-full"
      />
    </el-form-item>
    <layoutConfig
      :config="config"
      :layoutWidth="layoutWidth"
      :layout="layout"
      @layoutChange="layoutChange"
    />
  </el-form>
</template>

<script>
import { ColumApi } from '@wiz-api/workbench'
import layoutConfig from './LayoutConfig'
import { imageFitType } from '../../js/config'

const columnApi = new ColumApi()
export default {
  props: ['configData', 'layoutData', 'mode', 'layoutWidth', 'layout'],
  components: {
    layoutConfig,
  },
  data() {
    return {
      form: {
        dataSource: '', // 数据来源
        speed: 0,
        pageSize: 1, // 展示条数
        imageFit: 'fill',
      },
      config: {
        w: 10,
        h: 10,
      },
      columnData: [],
      imageFitType,
    }
  },
  watch: {
    configData: {
      deep: true,
      immediate: true,
      handler(val) {
        this.form = this.$options.data().form
        if (!_.isEmpty(val)) {
          _.assign(this.form, val)
        } else {
          this.selectChange()
        }
      },
    },
    layoutData: {
      deep: true,
      immediate: true,
      handler(val) {
        if (!_.isEmpty(val)) {
          this.config = _.pick(this.layoutData, ['w', 'h', 'type', 'component', 'x', 'y', 'i'])
        }
      },
    },
  },
  methods: {
    async getColumnData() {
      const [err, res] = await columnApi.tree(1)
      if (!err) {
        this.columnData = _.filter(res, (item) => {
          return item.type === this.config.type
        })
      }
    },
    selectChange() {
      this.$emit('configChange', this.form)
    },
    layoutChange(val) {
      this.config = _.cloneDeep(val)
      this.$emit('layoutChange', val)
    },
  },
  created() {
    this.getColumnData()
  },
}
</script>

<style></style>
